/* Bundle builder (sections/mv-pakket.liquid). Kaartjes voegen een variant toe via /cart/add.js; de vaste balk
   onderaan toont de stuks uit de collecties van deze sectie, de voortgang naar de volgende staffel en een
   afrekenknop. Na elke wijziging een CartLinesUpdateEvent (action "update", met de regel-id's uit het antwoord)
   zodat Horizon's teller en lade bijwerken; "update" i.p.v. "add" zodat de lade niet bij elk stuk openklapt. Rekent geen korting uit. */
import { CartLinesUpdateEvent } from '@shopify/events';

(() => {
  if (customElements.get('mv-pakket')) return;

  const twee = (n) => String(n).padStart(2, '0');

  class MvPakket extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.tiers = this.leesJson('[data-mv-pk-tiers]', []).filter((t) => Number(t.items) > 0)
        .sort((a, b) => a.items - b.items);
      this.productIds = new Set([...this.querySelectorAll('[data-mv-pk-product]')].map((k) => Number(k.dataset.mvPkProduct)));
      this.fout = this.querySelector('[data-mv-pk-fout]');
      this.addEventListener('change', (e) => {
        if (e.target.matches('.mv-pk__keuze')) this.werkKaartBij(e.target.closest('[data-mv-pk-product]'));
      }, { signal });
      this.addEventListener('click', (e) => {
        const voeg = e.target.closest('[data-mv-pk-voeg]');
        if (voeg) { this.voegToe(voeg.closest('[data-mv-pk-product]'), voeg); return; }
        const weg = e.target.closest('[data-mv-pk-weg]');
        if (weg) this.haalWeg(weg);
      }, { signal });
      document.addEventListener('visibilitychange', () => { if (!document.hidden) this.laadWagen(); }, { signal });
      this.querySelectorAll('[data-mv-pk-product]').forEach((k) => this.werkKaartBij(k));
      this.startKlok();
      this.laadWagen();
    }

    disconnectedCallback() {
      this.abort?.abort();
      clearInterval(this.klokTimer);
    }

    leesJson(sel, terug, wortel = this) {
      try { return JSON.parse(wortel.querySelector(sel)?.textContent || ''); } catch { return terug; }
    }

    variantVan(kaart) {
      const lijst = this.leesJson('[data-mv-pk-varianten]', [], kaart);
      const keuzes = [...kaart.querySelectorAll('.mv-pk__keuze')].map((s) => s.value);
      if (!keuzes.length) return lijst[0];
      return lijst.find((v) => v.opties.every((o, i) => o === keuzes[i]));
    }

    werkKaartBij(kaart) {
      if (!kaart) return;
      const v = this.variantVan(kaart);
      const knop = kaart.querySelector('[data-mv-pk-voeg]');
      if (knop) knop.disabled = !(v && v.beschikbaar);
      const prijs = kaart.querySelector('[data-mv-pk-prijs]');
      if (prijs && v) prijs.textContent = v.prijs;
      const img = kaart.querySelector('[data-mv-pk-beeld]');
      if (img && v?.beeld) { img.removeAttribute('srcset'); img.src = v.beeld; }
    }

    toonFout(tekst) {
      if (!this.fout) return;
      this.fout.textContent = tekst;
      this.fout.hidden = !tekst;
    }

    // eerst de winkelwagen wijzigen, dan Horizon melden met de nieuwe stand (action "update" met regel-id's)
    async wijzig(url, body, regelsVan) {
      try {
        const antwoord = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        }).then((r) => r.json());
        const wagen = await fetch(`${window.Theme?.routes?.cart_url || '/cart'}.js`).then((r) => r.json());
        const fout = Boolean(antwoord.status);
        this.tekenWagen(wagen);
        const lines = fout ? [] : regelsVan(antwoord, wagen);
        if (lines.length) {
          const uitgesteld = CartLinesUpdateEvent.createPromise();
          this.dispatchEvent(new CartLinesUpdateEvent({ action: 'update', context: 'cart', lines, promise: uitgesteld.promise }));
          uitgesteld.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(wagen), detail: { items: wagen.items, source: 'mv-pakket', didError: false } });
        }
        return !fout;
      } catch (fout) {
        console.error('[mv-pakket] winkelwagen bijwerken mislukt', fout);
        return false;
      }
    }

    async voegToe(kaart, knop) {
      const v = this.variantVan(kaart);
      if (!v || !v.beschikbaar) { this.toonFout(this.dataset.tekstFout); return; }
      this.toonFout('');
      knop.disabled = true;
      const gelukt = await this.wijzig(window.Theme?.routes?.cart_add_url || '/cart/add.js',
        { items: [{ id: v.id, quantity: 1 }] },
        (antwoord) => (antwoord.items || []).map((i) => ({ id: i.key, quantity: i.quantity })));
      if (!gelukt) this.toonFout(this.dataset.tekstFout);
      this.werkKaartBij(kaart);
    }

    async haalWeg(knop) {
      knop.disabled = true;
      const sleutel = knop.dataset.mvPkWeg;
      const regel = (this.wagen?.items || []).find((i) => i.key === sleutel);
      if (!regel) { this.laadWagen(); return; }
      await this.wijzig(window.Theme?.routes?.cart_change_url || '/cart/change.js',
        { id: sleutel, quantity: regel.quantity - 1 },
        () => [{ id: sleutel, quantity: regel.quantity - 1 }]);
    }

    async laadWagen() {
      try {
        const wagen = await fetch(`${window.Theme?.routes?.cart_url || '/cart'}.js`).then((r) => r.json());
        this.tekenWagen(wagen);
      } catch (fout) {
        console.error('[mv-pakket] winkelwagen ophalen mislukt', fout);
      }
    }

    // alleen de stuks uit de collecties van deze sectie tellen mee
    tekenWagen(wagen) {
      this.wagen = wagen;
      const regels = (wagen.items || []).filter((i) => this.productIds.has(Number(i.product_id)));
      const aantal = regels.reduce((t, i) => t + i.quantity, 0);
      this.querySelector('[data-mv-pk-teller]').textContent = aantal;
      this.tekenSlots(regels);
      this.tekenVoortgang(aantal);
    }

    tekenSlots(regels) {
      const lijst = this.querySelector('[data-mv-pk-slots]');
      const slots = Number(this.dataset.slots) || 5;
      const stuks = regels.flatMap((r) => Array(r.quantity).fill(r));
      const zichtbaar = stuks.slice(0, slots);
      lijst.replaceChildren(...Array.from({ length: slots }, (_, i) => {
        const li = document.createElement('li');
        const r = zichtbaar[i];
        if (!r) {
          li.className = 'mv-pk__slot mv-pk__slot--leeg';
          li.textContent = String(i + 1);
          return li;
        }
        li.className = 'mv-pk__slot';
        if (r.image) {
          const img = document.createElement('img');
          img.src = r.image + (r.image.includes('?') ? '&' : '?') + 'width=120';
          img.alt = r.title;
          img.width = 60;
          img.height = 75;
          img.loading = 'lazy';
          li.append(img);
        }
        const weg = document.createElement('button');
        weg.type = 'button';
        weg.className = 'mv-pk__weg';
        weg.dataset.mvPkWeg = r.key;
        weg.setAttribute('aria-label', `${this.dataset.tekstWeg || 'Remove'}: ${r.title}`);
        weg.innerHTML = '<svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true"><path d="m4 4 16 16M20 4 4 20" stroke="currentColor" stroke-width="2.5"/></svg>';
        li.append(weg);
        if (i === slots - 1 && stuks.length > slots) {
          const meer = document.createElement('span');
          meer.className = 'mv-pk__meer';
          meer.textContent = `+${stuks.length - slots}`;
          li.append(meer);
        }
        return li;
      }));
    }

    tekenVoortgang(aantal) {
      const tekst = this.querySelector('[data-mv-pk-voortgang]');
      const baan = this.querySelector('[data-mv-pk-baan]');
      if (!tekst || !this.tiers.length) return;
      const volgende = this.tiers.find((t) => aantal < t.items);
      const hoogste = this.tiers[this.tiers.length - 1];
      if (volgende) {
        tekst.textContent = (this.dataset.tekstVolgende || '')
          .replaceAll('[[items]]', volgende.items - aantal).replaceAll('[[percentage]]', volgende.pct);
        baan.style.transform = `scaleX(${Math.min(1, aantal / volgende.items)})`;
      } else {
        tekst.textContent = (this.dataset.tekstBereikt || '').replaceAll('[[percentage]]', hoogste.pct);
        baan.style.transform = 'scaleX(1)';
      }
    }

    // klok die vanaf de startdatum elke N uur opnieuw begint (zoals de NL-banner)
    startKlok() {
      const klok = this.querySelector('[data-mv-pk-klok]');
      const start = Date.parse(`${this.dataset.start}T00:00:00`);
      const periode = (Number(this.dataset.uren) || 24) * 3600 * 1000;
      if (!klok || Number.isNaN(start)) return;
      const u = klok.querySelector('[data-mv-pk-u]');
      const m = klok.querySelector('[data-mv-pk-m]');
      const tik = () => {
        const over = periode - (((Date.now() - start) % periode) + periode) % periode;
        const min = Math.floor(over / 60000);
        u.textContent = twee(Math.floor(min / 60));
        m.textContent = twee(min % 60);
      };
      tik();
      klok.hidden = false;
      this.klokTimer = setInterval(tik, 15000);
    }
  }

  customElements.define('mv-pakket', MvPakket);
})();
